import React from "react";

const ProjectsSection = ({ projects = [] }) => {
  return (
    <section className="py-24 px-6 bg-[#050816]">
      
      {/* HEADING */}
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold">
          Our <span className="text-purple-400">Projects</span>
        </h2>
        <p className="text-gray-400 mt-4">
          Real work. Real results. Real impact.
        </p>
      </div>

      {/* GRID */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
        
        {projects.map((project, i) => (
          <a
            key={i}
            href={project.link}
            target="_blank"
            rel="noreferrer"
            className="group relative rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-xl hover:-translate-y-2 transition duration-500"
          >
            
            {/* GLOW EFFECT */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-r from-purple-500/20 to-pink-500/20 blur-xl"></div>

            {/* CARD CONTENT */}
            <div className="relative z-10 p-6 flex flex-col h-full">

              {/* TOP BADGE */}
              <div className="flex justify-between items-center mb-4">
                <span className="text-xs px-3 py-1 bg-purple-500/20 text-purple-300 rounded-full">
                  Live Project
                </span>

                <span className="text-gray-400 text-sm group-hover:text-purple-400 transition">
                  ↗
                </span>
              </div>

              {/* TITLE */}
              <h3 className="text-xl font-semibold mb-3 group-hover:text-purple-400 transition">
                {project.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="text-gray-400 text-sm flex-grow">
                {project.desc}
              </p>

              {/* FOOTER */}
              <div className="mt-6 flex items-center justify-between">
                <span className="text-xs text-gray-500">
                  View Live Site
                </span>

                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-purple-500 transition">
                  →
                </div>
              </div>

            </div>
          </a>
        ))}

      </div>
    </section>
  );
};

export default ProjectsSection;